<script lang="ts" setup>
	import StringMethods from '~/utils/character'

	defineProps<{
		imgSrc: string
		role: string
		profile?: {
			first_name?: string
			last_name?: string
			email?: string
			phone?: string
			gender?: string
			house_address?: string
		} | null
	}>()
	const { stripUnderScore } = StringMethods()
</script>

<template>
	<shared-card default-class="w-full px-0 max-w-[292px] sm:min-w-[292px] pb-5 border px-7 hidden xl:block">
		<div class="flex flex-none flex-col items-center justify-center gap-y-10 border-b py-6">
			<div class="rounded-full bg-purple-100 px-6 py-3 text-sm font-medium text-purple-400"> Public Profile </div>

			<div class="flex flex-col items-center justify-center gap-y-5">
				<div
					class="flex h-16 w-16 flex-none items-center justify-center overflow-hidden rounded-full bg-purple-50 md:h-[78px] md:w-[78px]"
				>
					<span class="font-semibold uppercase text-blue-950 md:text-xl">
						{{ profile?.first_name?.[0] || '' }}{{ profile?.last_name?.[0] || 'N/A' }}
					</span>
				</div>

				<div class="space-y-1 text-center">
					<h1 class="text-sm font-medium capitalize leading-snug text-gray-700">
						{{ profile?.first_name }} {{ profile?.last_name || 'N/A' }}
					</h1>

					<p class="mt-0 pt-0 text-xs font-light capitalize leading-tight text-purple-500">
						{{ role }}
					</p>
				</div>
			</div>
		</div>

		<ul class="mt-5 space-y-7">
			<template v-for="(item, k) in profile || []" :key="k">
				<li v-if="!['full_name'].includes(k)" class="space-y- py-1 capitalize">
					<span class="block text-xs font-normal text-gray-500">
						{{ stripUnderScore(k) }}
					</span>
					<h3
						class="overflow-hidden text-ellipsis text-sm font-medium leading-tight tracking-wide text-gray-600"
					>
						{{ item || 'N/A' }}
					</h3>
				</li>
			</template>
		</ul>
	</shared-card>
</template>
